import { Layer } from '@hscmap/stellar-globe';
import Vue from 'vue';
import Component from 'vue-class-component';
import Globe from "./Globe/index.vue";
import { GlobeComponentType } from "./Globe/script";
import { HipsMaskLayerComponent as HipsMaskLayer, HipsPngLayerComponent as HipsPngLayer } from "./HiPSLayer";
import TextLayerComponent from './TextLayer';
import { LayerComponentBase } from "./layer_component_base";
import { TileLayerComponent, TileTextureProviderComponentBase } from "./tile_layer_component_base";

// tslint:disable-next-line:no-shadowed-variable variable-name
export function Layer2Component<T extends typeof Layer>(Layer: T) {
  @Component
  class LayerComponent extends LayerComponentBase<Layer> {
    newLayer() {
      return new Layer()
    }
  }
  return LayerComponent
}

export {
  Globe,
  GlobeComponentType,
  LayerComponentBase,
  HipsPngLayer,
  HipsMaskLayer,
  TileTextureProviderComponentBase,
  TileLayerComponent as TileLayer,
  TextLayerComponent as TextLayer,
};

export function install(vue: typeof Vue, options: { prefix: string }) {
  const { prefix } = options
  vue.component(`${prefix}-globe`, Globe)
  vue.component(`${prefix}-hips-png-layer`, HipsPngLayer)
  vue.component(`${prefix}-hips-mask-layer`, HipsMaskLayer)
  vue.component(`${prefix}-tile-layer`, TileLayerComponent)
}
